
<template>
  <div class="item-display">
    <div
      v-for="(property, key, index) in item.properties"
      v-bind:key="(key + index)"
      v-bind:class="[
        'card-property',
        'property-' + key,
        (isShowing(key) ? 'showing' : 'hidden'),
      ]"
    >
      <div v-if="property.type == 'imageArray'">
        <img v-bind:src="property.value[property.current]">
      </div>
      <div v-if="property.type == 'text'">
        <div v-if="key == 'thai'">
          <PhraseDetails v-bind:phrase="item.phrase" />
        </div>
        <div v-else>
          {{ property.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item-word-part {
  display: inline-block;
  // padding: 2px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.item-word-part:hover {
  background: #f5f5f5;
  border-bottom: 2px solid black;
}
</style>


<script>
import PhraseDetails from '@/components/PhraseDetails.vue';

export default {
  props: ["item", "showing"],
  components: {
    PhraseDetails,
  },
  methods: {
    isShowing (key) {
      return this.showing.indexOf(key) !== -1;
    },
    getWordParts(value) {
      var words = [];
      for (let word of value.split("-")) {
        words.push(word.trim());
      }
      return words;
    },
  },
  mounted: function() {
    console.log("item!!!!!!", this.item.properties);
  },
};
</script>